// extracted by mini-css-extract-plugin
module.exports = {"partnerActivityListItem":"SxEDE","partnerMaskWrapper":"qhTvl","partnerActivityDescription":"_16_VG"};